<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="editPersonEmploymentDialog"
            max-width="500px"
            persistent
        >
            <v-card>
                <DialogTitle
                    :close="closeEditItem"
                    :dialog-name="dialogName"
                />
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :items="ecsCompanyList"
                                    item-text="name"
                                    item-value="ecsCompanyId"
                                    label="ECS Company"
                                    v-model="editEcsCompanyId"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-autocomplete
                                    :items="liveJobList"
                                    item-text="name"
                                    item-value="jobId"
                                    label="Job"
                                    v-model="editJobId"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :items="employmentTypeList"
                                    item-text="name"
                                    item-value="employmentTypeId"
                                    label="Employment Type"
                                    v-model="editEmploymentTypeId"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    label="Weekly Hours"
                                    max="168"
                                    min="0"
                                    step="0.25"
                                    type="number"
                                    v-model="editWeeklyHours"
                                />
                            </v-flex>
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"

                                v-model="startDateMenu"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="editStartDate | formatDate"
                                        label="Start Date"
                                        prepend-icon="event"
                                        readonly
                                        slot="activator"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    :max="editEndDate"
                                    @input="startDateMenu = false"
                                    no-title
                                    scrollable
                                    v-model="editStartDate"
                                />
                            </v-menu>
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                min-width="290px"
                                offset-y
                                transition="scale-transition"

                                v-model="endDateMenu"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        label="End Date"
                                        prepend-icon="event"
                                        readonly
                                        slot="activator"
                                        :value="editEndDate | formatDate"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    :min="editStartDate"
                                    @input="endDateMenu = false"
                                    no-title
                                    scrollable
                                    v-model="editEndDate"
                                >
                                <v-btn text color="primary" @click="() => {this.editEndDate = null}">Clear</v-btn>
                                </v-date-picker>
                            </v-menu>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                                    @blur="$v.editIsAllowedToil.$touch()"
                                    @input="$v.editIsAllowedToil.$touch()"
                                    item-text="name"

                                    item-value="Id"
                                    label="Allowed TOIL"
                                    v-model="editIsAllowedToil"
                                />
                            </v-flex>
                            <v-flex
                                md6
                                sm6
                                xs12
                            >
                                <v-select
                                    :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                                    @blur="$v.editIsAllowedExpenses.$touch()"
                                    @input="$v.editIsAllowedExpenses.$touch()"
                                    item-text="name"

                                    item-value="Id"
                                    label="Allowed Expenses"
                                    v-model="editIsAllowedExpenses"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    counter
                                    label="Comments"

                                    maxlength="90"
                                    v-model="editComments"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <DialogActions
                    :close="closeEditItem"
                    :save="saveEditItemAndCloseDialog"
                />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from '../editTableFunctions';

    import {LOAD_PERSON_EMPLOYMENT_TO_EDIT, RESET_DEFAULT_PERSON_EMPLOYMENT_TO_EDIT, TOGGLE_EDIT_PERSON_EMPLOYMENT_DIALOG, UPDATE_PERSON_EMPLOYMENT_FIELD} from "@/store/person_employment/mutations";
    import {SAVE_EDITED_PERSON_EMPLOYMENT} from "@/store/person_employment/actions.js";
    import {FETCH_PERSON_EMPLOYMENT_LIST} from "../../../../store/person_employment/actions";
    import DialogTitle from "../../../../components/DialogTitle";
    import DialogActions from "../../../../components/DialogActions";

    export default {
        name: "EditPersonEmploymentDialog",

        validations: {
            // editAddressLineOne: { required },
            // editPostCode: { required },
            // editEmailAddressPersonal: { email },
        },

        components: {
            DialogActions,
            DialogTitle
        },

        mixins: [
            EditTableFunctions,
        ],

        props: {
            // item: {
            //     type: Object,
            //     required: true,
            // },
        },
        data() {
            return {
                // Required for editTableFunctions
                idName: 'feedbackId',
                dialogName: 'Edit Person Employment',
                startDateMenu: false,
                endDateMenu: false,
            }
        },
        computed: {
            editPersonEmploymentDialog: {
                get() {
                    return this.$store.state.person_employment.editPersonEmploymentDialog;
                },
            },
            editEcsCompanyId: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.ecsCompanyId;
                },
                set(value) {
                    this.updateEditedValue('ecsCompanyId', value);
                },
            },
            editJobId: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.jobId;
                },
                set(value) {
                    this.updateEditedValue('jobId', value);
                },
            },
            editEmploymentTypeId: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.employmentTypeId;
                },
                set(value) {
                    this.updateEditedValue('employmentTypeId', value);
                },
            },
            editWeeklyHours: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.weeklyHours;
                },
                set(value) {
                    this.updateEditedValue('weeklyHours', value);
                },
            },
            editStartDate: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.startDate;
                },
                set(value) {
                    this.updateEditedValue('startDate', value);
                },
            },
            editEndDate: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.endDate;
                },
                set(value) {
                    this.updateEditedValue('endDate', value);
                },
            },
            editComments: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.comments;
                },
                set(value) {
                    this.updateEditedValue('comments', value);
                },
            },
            editIsAllowedToil: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.isAllowedToil;
                },
                set(value) {
                    this.updateEditedValue('isAllowedToil', value);
                },
            },
            editIsAllowedExpenses: {
                get() {
                    return this.$store.state.person_employment.editPersonEmployment.isAllowedExpenses;
                },
                set(value) {
                    this.updateEditedValue('isAllowedExpenses', value);
                },
            },
            ...mapGetters(
            [
                "liveJobList",
                "employmentTypeList",
                "ecsCompanyList",
            ]
            ),
            ...mapGetters({
                id: "editPersonEmploymentPersonId"
            })
        },

        methods: {
            async validateAll() {

                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }

                let areValid = false;

                if (formState == 'complete') {
                    areValid = true;
                }

                return areValid;
            },

            ...mapActions({
                fetchItem: FETCH_PERSON_EMPLOYMENT_LIST,
                updateTableItemRecord: SAVE_EDITED_PERSON_EMPLOYMENT,
                // saveNewTableItemRecord: '',
                // deleteTableItem: '',
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_EMPLOYMENT_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_EMPLOYMENT_TO_EDIT,
                updateTableItemToEdit: UPDATE_PERSON_EMPLOYMENT_FIELD,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_EMPLOYMENT_TO_EDIT,
            })
        },

    }
</script>

<style scoped>
</style>
